<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ `${iframe_info.title}` ? iframe_info.title : "-" | t }}</v-toolbar-title>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer" />

        <!-- Main content -->
        <v-main>
            <iframe-page-view />
        </v-main>

        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import { mapState } from "vuex";
import IframePageView from "@/pages/iframe-page/iframe-page-view";

export default {
    components: {
        IframePageView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    mounted() {
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    methods: {
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        }
    },
    computed: {
        ...mapState("SalesInvoiceStore", ["drawerOpen"]),
        ...mapState(["iframe_info"])
    }
};
</script>

<style>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
